import { render, staticRenderFns } from "./RecipientsListEdit.vue?vue&type=template&id=43393bd6&scoped=true&"
import script from "./RecipientsListEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecipientsListEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43393bd6",
  null
  
)

export default component.exports